import * as actions from './alertActions';

const alertReducers = {
  [actions.ALERT_STORE_ALERT_INFO]: (state, { payload }) => {
    state.info = payload;
    return state;
  },
  [actions.ALERT_CLEAR_ALERT_INFO]: state => {
    delete state.info;
    return state;
  },
};

export default {
  name: 'alert',
  reducers: alertReducers,
};
